import { motion } from "framer-motion";
import { EASE } from "@/components/washflow/Reveal";

const shots = [
  {
    src: "https://images.unsplash.com/photo-1635274605638-d44babc08a4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGZyZXNoJTIwZm9sZGVkJTIwbGF1bmRyeSUyMGdhcm1lbnRzfGVufDB8fHx8MTc5Mjc2MTc0MXww&ixlib=rb-4.1.0&q=85",
    alt: "Fresh folded laundry stacked and ready for delivery",
    offset: "lg:translate-y-10",
    caption: "Every item counted",
  },
  {
    src: "https://images.pexels.com/photos/4440572/pexels-photo-4440572.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Hands carefully folding clean garments",
    offset: "lg:-translate-y-6",
    caption: "Handled with care",
  },
  {
    src: "https://images.pexels.com/photos/7163434/pexels-photo-7163434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Laundry business owner checking the live dashboard on a tablet",
    offset: "lg:translate-y-14",
    caption: "You, always in the know",
  },
];

export default function PhotoBand() {
  return (
    <section data-testid="photo-band" className="bg-white py-16 sm:py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="text-center font-display text-lg sm:text-xl font-bold text-[#5D6D7E] tracking-wide">
          Real shops. Real clothes. Real data.
        </p>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8 items-start">
          {shots.map((s, i) => (
            <div key={i} className={s.offset}>
              <motion.figure
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 1, delay: i * 0.15, ease: EASE }}
                className="group"
              >
              <div className="relative overflow-hidden rounded-[2rem] shadow-xl shadow-[#1B4F72]/10 aspect-[4/5]">
                <img
                  src={s.src}
                  alt={s.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 30% 15%, rgba(174,214,241,0.25), transparent 55%)" }} />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0F2B3E]/60 to-transparent" />
                <figcaption className="absolute bottom-5 left-6 right-6 font-display text-white font-bold text-lg drop-shadow">
                  {s.caption}
                </figcaption>
              </div>
              </motion.figure>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
